<template>
  <v-select
    prepend-icon="mdi-eye"
    label="View by..."
    item-text="text"
    item-value="value"
    :items="items"
    v-model="selected"
    @change="updateView"
  ></v-select>
</template>

<script>
export default {
  name: "ViewSelector",
  data() {
    return {
      selected: this.$store.state.Dashboard.widgetConfig.viewType,
    }
  },
  props: ['bus'],
  methods: {
    updateView(event) {
      this.$store.commit('setViewType', event );
      this.$emit('view-changed', event);
      console.log('Update view is triggered!!', event);
    }
  },
  computed: {
    items: function() {
      const options = [
        {
          text: 'By Date Range',
          value: 'date_range'
        },
        {
          text: 'By Department',
          value: 'department'
        },
        {
          text: 'By Region',
          value: 'region'
        },
        {
          text: 'By Store',
          value: 'store'
        }
      ];

      if (this.$store.state.Dashboard.widgetConfig.theme === 'conversion' && 1 !== 1) {
        options.push({
            text: 'By Service Type',
            value: 'service_type'
          });
        options.push({
            text: 'By Quote Type',
            value: 'quote_type'
          });
      }

      return options;
    }
  },
  created: function() {
    const instance = this;

    instance.bus.$on('trigger-view-update', function(val) {
      if (instance.$store.state.Dashboard.viewType === 'region') {
        instance.selected = 'store';
        instance.updateView('store');
      }
    });
  }
}
</script>

<style scoped>

</style>
